module.exports = {
	"modalConfirmation": "$1",
	"noResultsBannerTitle": "No Results Found",
	"noResultsBannerBody": "There is no recent pricing data for your selected drug.",
	"havePositionPlaceholder": "Current Location",
	"noPositionPlaceholder": "Search For A Location",
	"getMarkerError": "The marker was not found",
	"drugFetchFailure": "Failed to retrieve critical data, retrying...",
	"drugFetchFailureFatalTitle": "Database Connection Error",
	"drugFetchFailureFatalBody": "There was an error connecting to the database. Please try again later.",
	"pillPrice": " $$3 per pill - $1 ($2)",
	"dispensingFee": "$$1 - Dispensing Fee",
	"genericEquivalent": "Generic Equivalent",
	"perPill": "$$1 per pill",
	"noCurrentData": "No Current Pricing - $1 $2",
	"preferredProvider": "Preferred Pharmacy",
	"preferredProviderDetails": "Pacific Blue Cross has partnered with leading pharmacy brands to offer our plan members guaranteed low prices and dispensing fees, and help navigating coverage for high-cost drugs.",
	"readMore": "Read More",
	"otherPharmacy": "Other Pharmacy",
	"specialAuthority": "Special Authority",
	"specialAuthorityDetails": "Certain drugs require approval by BC PharmaCare. If you’ve been approved and are a Pacific Blue Cross plan member, go directly to these pharmacies to fill your prescription.  They will instantly send confirmation of your coverage to Pacific Blue Cross.",
	"location": "Location",
	"buyGeneric": "Benefits of Buying Generic",
	"whatIsPharmacyCompass": "Use Pharmacy Compass to compare prescription prices of pills and tablets at pharmacies in British Columbia",
	"whatIsPharmacyCompassDetail": "<ul><li>Enter your drug name or DIN # (pills or tablets only)</li><li>Price results will appear below</li><li>Enable your location to see pharmacies nearest you</li></ul><a href='$1' target='_blank'>Read More</a>"
};


//////////////////
// WEBPACK FOOTER
// ./Locales/en.json
// module id = 34
// module chunks = 0